export const RFP_ACTION = {};
RFP_ACTION.VIEW_RFP_MODAL = "VIEW_RFP_MODAL";
RFP_ACTION.CLOSE_VIEW_RFP_MODAL = "CLOSE_VIEW_RFP_MODAL";
RFP_ACTION.ADD_MATERIALS_MODAL = "ADD_MATERIALS_MODAL";
RFP_ACTION.CLOSE_ADD_MATERIAL_MODAL = "CLOSE_ADD_MATERIAL_MODAL";
RFP_ACTION.UPDATE_LIST_OF_MATERIALS = "UPDATE_LIST_OF_MATERIALS";
RFP_ACTION.UPDATE_SELECTED_MATERIALS_LIST = "UPDATE_SELECTED_MATERIALS_LIST";
RFP_ACTION.CONFIRM_CLOSE_ADD_MATERIAL_MODAL =
  "CONFIRM_CLOSE_ADD_MATERIAL_MODAL";
RFP_ACTION.ON_REMOVE_SELECT_SUPPLIER_HANDLER =
  "ON_REMOVE_SELECT_SUPPLIER_HANDLER";
RFP_ACTION.UPDATE_WAITING_RFP_LIST = "UPDATE_WAITING_RFP_LIST";
RFP_ACTION.UPDATE_RFP_BADGE_COUNT = "UPDATE_RFP_BADGE_COUNT";

RFP_ACTION.INITIAL_STATE_RFP_STORE = "INITIAL_STATE_RFP_STORE";
RFP_ACTION.UPDATE_INPROGRESS_RFP_LIST = "UPDATE_INPROGRESS_RFP_LIST";
RFP_ACTION.UPDATET_RFP_LIST = "UPDATET_RFP_LIST";
RFP_ACTION.UPDATE_DEFAULT_RFP = "UPDATE_DEFAULT_RFP";
RFP_ACTION.UPDATE_RFP_DETAILS_INFO = "UPDATE_RFP_DETAILS_INFO";
RFP_ACTION.UPDATE_RFP_DETAILS_INFO_BY_DEFAULT =
  "UPDATE_RFP_DETAILS_INFO_BY_DEFAULT";

RFP_ACTION.VIEW_DOC_MODAL = "VIEW_DOC_MODAL";
RFP_ACTION.CLOSE_VIEW_DOC_MODAL = "CLOSE_VIEW_DOC_MODAL";

RFP_ACTION.UPDATE_NOTE = "UPDATE_NOTE";
//متن درخواست
RFP_ACTION.ACTIVE_REQUEST_TEXT = "ACTIVE_REQUEST_TEXT";
//تامین کنندگان
RFP_ACTION.SUPPLIER_MODAL_TOGGLE = "SUPPLIER_MODAL_TOGGLE";
RFP_ACTION.ACTIVE_SUPPLIER_CMP = "ACTIVE_SUPPLIER_CMP";
RFP_ACTION.CLOSE_ADD_SUPPLIER_MODAL = "CLOSE_ADD_SUPPLIER_MODAL";
RFP_ACTION.CONFIRM_CLOSE_ADD_NEW_SUPPLIER_MODAL =
  "CONFIRM_CLOSE_ADD_NEW_SUPPLIER_MODAL";
RFP_ACTION.UPDATE_SELECTED_SUPPLIER_LIST = "UPDATE_SELECTED_SUPPLIER_LIST";
RFP_ACTION.UPDATE_ADDED_NEW_SUPPLIER = "UPDATE_ADDED_NEW_SUPPLIER";
RFP_ACTION.ON_ALL_REMOVE_SUPPLIER_HANDLER = "ON_ALL_REMOVE_SUPPLIER_HANDLER";
RFP_ACTION.UPDATE_LIST_OF_SUPPLIER = "UPDATE_LIST_OF_SUPPLIER";
//استعلام
RFP_ACTION.TECHNICAL_INQUIRY_HANDLER = "TECHNICAL_INQUIRY_HANDLER";
RFP_ACTION.BUSINESS_INQUIRY_HANDLER = "BUSINESS_INQUIRY_HANDLER";
RFP_ACTION.UPDATE_TECHNICAL_INQUIRY_LIST = "UPDATE_TECHNICAL_INQUIRY_LIST";
RFP_ACTION.UPDATE_BUSINESS_INQUIRY_LIST = "UPDATE_BUSINESS_INQUIRY_LIST";

//---advanced search filter ----
RFP_ACTION.ADVANCED_SEARCH_FILTER = "ADVANCED_SEARCH_FILTER";

RFP_ACTION.OPEN_CONFIRM_MODAL = "OPEN_CONFIRM_MODAL";
RFP_ACTION.CLOSE_CONFIRM_MODAL = "CLOSE_CONFIRM_MODAL";

//----- Propsal modal ----
RFP_ACTION.PROPSAL_MODAL = "PROPSAL_MODAL";
RFP_ACTION.CLOSE_PROPSAL_MODAL = "CLOSE_PROPSAL_MODAL";

RFP_ACTION.CLOSE_DETAILS_MATERIAL_MODAL = "CLOSE_DETAILS_MATERIAL_MODAL";
RFP_ACTION.CONFIRM_CLOSE_DETAILS_MATERIAL_MODAL =
  "CONFIRM_CLOSE_DETAILS_MATERIAL_MODAL";

RFP_ACTION.CLOSE_DETAILS_SUPPLIER_MODAL = "CLOSE_DETAILS_SUPPLIER_MODAL";
RFP_ACTION.CONFIRM_CLOSE_DETAILS_SUPPLIER_MODAL =
  "CONFIRM_CLOSE_DETAILS_SUPPLIER_MODAL";

RFP_ACTION.UPDATE_SELECTED_SUPPLIER_LIST_FOR_DETAILS =
  "UPDATE_SELECTED_SUPPLIER_LIST_FOR_DETAILS";

RFP_ACTION.UPDATE_SELECTED_MATERIALS_LIST_FOR_DETAILS =
  "UPDATE_SELECTED_MATERIALS_LIST_FOR_DETAILS";

RFP_ACTION.INQUIRY_MODAL_TOGGLE = "INQUIRY_MODAL_TOGGLE";
RFP_ACTION.CLOSE_INQUIRY_MODAL_TOGGLE = "CLOSE_INQUIRY_MODAL_TOGGLE";
RFP_ACTION.CONFIRM_INQUIRY_MODAL_TOGGLE = "CONFIRM_INQUIRY_MODAL_TOGGLE";
RFP_ACTION.UPDATE_INQUIRY_LIST = "UPDATE_INQUIRY_LIST";

RFP_ACTION.UPDATE_PROPOSAL_ARRAY = "UPDATE_PROPOSAL_ARRAY";

RFP_ACTION.UPDATE_PROPSAL_COMMENTS_REPLY = "UPDATE_PROPSAL_COMMENTS_REPLY";

RFP_ACTION.UPDATE_RFP_STATUS = "UPDATE_RFP_STATUS";

RFP_ACTION.UPDATE_RFP_EVALUATION = "UPDATE_RFP_EVALUATION";

RFP_ACTION.UPDATE_EVALUATION_SCORE = "UPDATE_EVALUATION_SCORE";

RFP_ACTION.WINNER_MODAL_TOGGLE = "WINNER_MODAL_TOGGLE";
RFP_ACTION.CONFIRM_WINNER_MODAL = "CONFIRM_WINNER_MODAL";

RFP_ACTION.UPDATE_EVALUATION_NOTE = "UPDATE_EVALUATION_NOTE";
